import React from "react";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import { makeStyles } from '@material-ui/core/styles';
import RemoveIcon from '@material-ui/icons/Remove';

const useStyles = makeStyles(() => ({
    flex_box: {
        display:"flex",
        justifyContent: "start",
    },
    text:{
        alignSelf:"center"
    }
}));




function ExtraChild(props) {
    const classes = useStyles();
    console.log(props)

    const addChild = <React.Fragment>
        <IconButton onClick={props.extraChildStatus}>
            <AddIcon style={{color:"#BB6BD9"}}/>
        </IconButton>
        <div className={classes.text}>הוסף ילד</div>
    </React.Fragment>;

    const removeChild = <React.Fragment>
        <IconButton onClick={props.extraChildStatus}>
            <RemoveIcon style={{color:"#BB6BD9"}}/>
        </IconButton>
        <div className={classes.text}>הסר ילד נוסף</div>
    </React.Fragment>;
    return(
        <div className={classes.flex_box}>
            {props.extra_child ? removeChild : addChild}
        </div>

    )
}

export default ExtraChild